import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const dashboardPaginationFiltersApi = createApi({
  reducerPath: reducerPaths.dashboardPaginationFiltersApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getVehicleMakes: builder.query({
      query: ({ method }) => {
        return {
          url: `/get-year-make`,
          method: "GET",
        };
      },
    }),
    getVehicleModels: builder.mutation({
      query: ({ method, payload }) => {
        return {
          url: `/get-model`,
          method: method || "POST",
          body: payload,
        };
      },
    }),
    getTimeoutDetails: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/timeoutdetails/${vehicleId}`,
        };
      },
    }),
  }),
});

export const {
  useGetVehicleMakesQuery,
  useGetVehicleModelsMutation,
  useGetTimeoutDetailsQuery,
} = dashboardPaginationFiltersApi;

export const {
  useLazyGetVehicleMakesQuery,
  useLazyGetTimeoutDetailsQuery,
} = dashboardPaginationFiltersApi;
